import { Column, Entity, PrimaryColumn } from 'typeorm';

/**
 * 計測中間情報テーブル。
 * Reconstruct の結果を保持する。
 */
@Entity()
export class MeasurementIntermediateInfoSchema {

  @PrimaryColumn()
    inspectionImageId: string;

  @Column({ nullable: true })
    productInfo: string | null;

  @Column({ nullable: true })
    areaInfo: string | null;

  @Column({ nullable: true })
    type: string | null;

  @Column({ nullable: true })
    libVersion: string | null;

}
